import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "3",
  height: "14"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Group 5362" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8191",
    d: "M1.5 14A1.5 1.5 0 1 0 0 12.5 1.5 1.5 0 0 0 1.5 14z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8192",
    d: "M1.5 8.5A1.5 1.5 0 1 0 0 7a1.5 1.5 0 0 0 1.5 1.5z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8193",
    d: "M1.5 3A1.5 1.5 0 1 0 0 1.5 1.5 1.5 0 0 0 1.5 3z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };